import { z } from "zod"

const gaugesItem = z.object({
  id: z.number(),
  address: z.string(),
  bribeAddress: z.string(),
  pairAddress: z.string(),
  apr: z.string(),
  aprLastEpoch: z.string(),
  rewardRate: z.string(),
  token0: z.object({
    symbol: z.string(),
    address: z.string(),
    priceUsd: z.number(),
    reserve: z.string(),
    reserveUsd: z.number(),
  }),
  token1: z.object({
    symbol: z.string(),
    address: z.string(),
    priceUsd: z.number(),
    reserve: z.string(),
    reserveUsd: z.number(),
  }),
  totalSupply: z.string(),
  votes: z.string(),
  votesPercent: z.string(),
  incentives: z.record(
    z.string(),
    z.object({
      symbol: z.string(),
      priceUsd: z.number(),
      rewardAmount: z.number(),
      rewardAmountUsd: z.number(),
    }),
  ),
  pair: z.object({
    address: z.string(),
    displayName: z.string().nullable(),
    displayType: z.string().nullable(),
    extendedType: z.string().nullable(),
    tags: z.array(z.string()),
  }),
  rewards: z.string().nullable().optional(),
  reward: z.string().nullable().optional(),
  tbv: z.number(),
  tbvUsd: z.string().optional(),
  tbvUSD: z.string().optional(),
  weightPercent: z.string(),
})

export const gaugesResponseSchema = z.record(z.string(), gaugesItem)

export type GaugesResponse = z.infer<typeof gaugesResponseSchema>
export type GaugesResponseItem = GaugesResponse[number]
